module.exports = __webpack_public_path__ + "static/financial-89d2b509f4b9df28e8af6c2ba3516fea.png";